export default __webpack_public_path__ + "static/media/proditem1.e4a71867.webp";